<template>
  <div class="personal-detail-3">

    <!-- 这里的翻译希望没错哟 -->
    <h4>{{$t('headerMsg.financialDetails')}}</h4>
     
    <el-form :model="formData" status-icon :rules="rules" ref="ruleForm" label-position="top">
      <el-row :gutter="20">

        <!-- 就业状态 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('financialDetails.Emp_Status')" prop="Emp_Status">
            <el-radio-group @change="radioChange" v-model="formData.Emp_Status">
              <div class="radio-list-h5">
                <div class="radio-h5"><el-radio label="1">{{$t('financialDetails.employmentStatusSelect.b')}}</el-radio></div>
                <div class="radio-h5"><el-radio label="0">{{$t('financialDetails.employmentStatusSelect.a')}}</el-radio></div>
                <div class="radio-h5"><el-radio label="2">{{$t('financialDetails.employmentStatusSelect.c')}}</el-radio></div>
                <div class="radio-h5"><el-radio label="4">{{$t('financialDetails.employmentStatusSelect.e')}}</el-radio></div>
                <div class="radio-h5"><el-radio label="3">{{$t('financialDetails.employmentStatusSelect.d')}}</el-radio></div>
              </div>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- 行业  隐藏select -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '1'">
          <el-form-item :label="$t('financialDetails.Industry_Sector')" prop="Industry_Sector">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Industry_Sector" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Industry_Sector')">
              <el-option v-for="(item, index) in $t('financialDetails.Industry_Sector_select')" :key="index" :label="item"
                :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 无选项提供需注明，其他行业  隐藏input -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '1' && formData.Industry_Sector == '16'">
          <el-form-item :label="$t('financialDetails.Other_Industry_Sector')" prop="Other_Industry_Sector">
            <el-input v-model="formData.Other_Industry_Sector"></el-input>
          </el-form-item>
        </el-col>

        <!-- 职位  隐藏select -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '1'">
          <el-form-item :label="$t('financialDetails.Position')" prop="Position">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Position" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Position')">
              <el-option v-for="(item, index) in $t('financialDetails.FD_Position_select')" :key="index" :label="item"
                :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 无选项提供需注明，其他职位  隐藏input -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '1' && formData.Position == '7'">
          <el-form-item :label="$t('financialDetails.Other_Position')" prop="Other_Position">
            <el-input v-model="formData.Other_Position"></el-input>
          </el-form-item>
        </el-col>

        <!-- 自由职业 / 个体商业户  隐藏select -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '0'">
          <el-form-item :label="$t('financialDetails.Freelance_OwnACompany')" prop="Freelance_OwnACompany">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Freelance_OwnACompany" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Freelance_OwnACompany')">
              <el-option v-for="(item, index) in $t('financialDetails.Freelance_OwnACompany_select')" :key="index"
                :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 公司名称  隐藏input -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '1' || (formData.Emp_Status == '0' && formData.Freelance_OwnACompany == '1')">
          <el-form-item :label="$t('financialDetails.Employer')" prop="Employer">
            <el-input v-model="formData.Employer"></el-input>
            <!-- <small>{{$t('messages.employerName')}}</small> -->
          </el-form-item>
        </el-col>

        <!-- 经营范围  隐藏select -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '0' && (formData.Freelance_OwnACompany == '0' || formData.Freelance_OwnACompany == '1')">
          <el-form-item :label="$t('financialDetails.Biz_Nature')" prop="Biz_Nature">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Biz_Nature" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Biz_Nature')">
              <el-option v-for="(item, index) in $t('financialDetails.Industry_Sector_select')" :key="index" :label="item"
                :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 无选项提供需注明，其他经营范围  隐藏input -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Emp_Status == '0' && formData.Biz_Nature == '16'">
          <el-form-item :label="$t('financialDetails.Other_Biz_Nature')" prop="Other_Biz_Nature">
            <el-input v-model="formData.Other_Biz_Nature"></el-input>
          </el-form-item>
        </el-col>




        <!-- 您的年总收入（一年内所有能赚取的收入，包括薪金、养老金、利息、红利、租金等） -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="no-left">
           <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
               <el-form-item :label="$t('financialDetails.Annual_Income')" prop="Annual_Income">
                 <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Annual_Income" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Annual_Income')">
                   <el-option v-for="(item, index) in $t('financialDetails.annualIncomeSelect')" :key="index" :label="item"
                              :value="index"></el-option>
                 </el-select>
                 <small>{{$t('financialDetails.Annual_Income_word')}}</small>
               </el-form-item>
           </el-col>

          <!--输入数额-->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" >
            <el-form-item :label="$t('financialDetails.Annual_Income_Total')" prop="Annual_Income_Total" v-if="formData.Annual_Income=='0'">
              <el-input type="Number" maxlength=18 v-model="formData.Annual_Income_Total" @keyup.native="proving"></el-input>
            </el-form-item>
          </el-col>

        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="no-left">
          <!-- 您的储蓄和投资总额 （到目前为止所有的储蓄和投资，包括银行和投资平台的存款、证券、基金、债券和其他投资等） -->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('financialDetails.Total_Saving_Investments')" prop="Total_Saving_Investments">
              <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Total_Saving_Investments" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Total_Saving_Investments')">
                <el-option v-for="(item, index) in $t('financialDetails.Total_Saving_Investments_select')" :key="index"
                           :label="item" :value="index"></el-option>
              </el-select>
              <small>{{$t('financialDetails.Total_Saving_word')}}</small>
            </el-form-item>
          </el-col>

          <!--存储数额-->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" >

            <el-form-item :label="$t('financialDetails.Saving_Investments_Money')" prop="Saving_Investments_Money" v-if="formData.Total_Saving_Investments=='0'">
              <el-input type="Number" maxlength=18  v-model="formData.Saving_Investments_Money" @keyup.native="proving2"></el-input>
            </el-form-item>

          </el-col>


        </el-col>

        <!-- 其他收入来源 -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('financialDetails.Funds_Source')" prop="Funds_Source">
            <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Funds_Source" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Funds_Source')">
              <el-option v-for="(item, index) in $t('financialDetails.fundsSourceSelect')" :key="index" :label="item"
                :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 无选项提供需注明，其他收入来源  隐藏input -->
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="formData.Funds_Source == '6'">
          <el-form-item :label="'* '+ $t('financialDetails.Other_Funds_Source')" prop="Other_Funds_Source">
            <el-input v-model="formData.Other_Funds_Source"></el-input>
          </el-form-item>
        </el-col>

        <!-- 在ATFX的预计投资额为多少美元？ -->
        <el-col  :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="no-left">

          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('financialDetails.Intend_Deposit')" prop="Intend_Deposit">
              <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Intend_Deposit" class="select-width" :placeholder="$t('customErrMsg.fieldIsRequired.Intend_Deposit')">
                <el-option v-for="(item, index) in $t('financialDetails.intendDepositSelect')" :key="index" :label="item"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-col>



        <!-- 暂时英文显示 新加字段  -->
        <template >
          <!-- 你能承受损失你计划投资的资金吗？ -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('financialDetails.Afford_To_Lose')"  prop="Afford_To_Lose">
              <el-radio-group  v-model="formData.Afford_To_Lose">
                <div class="radio-h5">
                  <el-radio label="Y">{{$t('financialDetails.Afford_To_Lose_Select.Y')}}</el-radio>
                </div>
                <div class="radio-h5">
                  <el-radio label="N">{{$t('financialDetails.Afford_To_Lose_Select.N')}}</el-radio>
                </div>
              </el-radio-group>
              <br/>
              <small class="el-form-item__error" v-if="err_Afford_To_Lose">{{$t('financialDetails.Afford_To_Lose_Error')}}</small>
            </el-form-item>

          </el-col>

          <!-- 你为什么要在atfx开一个交易账户？ -->
         <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="financial-radio">
            <el-form-item :label="$t('financialDetails.Open_Trading_Account')" prop="Open_Trading_Account">
              <el-radio-group v-model="formData.Open_Trading_Account">
                <div class="jz-radio radio-h5">
                  <el-radio label="0">{{$t('financialDetails.Open_Trading_Account_Select.0')}}</el-radio>
                </div>
                <div class="jz-radio radio-h5">
                  <el-radio label="1">{{$t('financialDetails.Open_Trading_Account_Select.1')}}</el-radio>
                </div>
                <div class="jz-radio radio-h5">
                  <el-radio label="2">{{$t('financialDetails.Open_Trading_Account_Select.2')}}</el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>

        </template>


      </el-row>
    </el-form>

    <h4 >{{$t('financialDetails.ATFX_Client_Pro')}}</h4>

  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  export default {
    mixins: [
      require("@/assets/mixin/base.js").base('financialDetails')
    ],
    props: ['Lead', 'middle_dataware'],
    data() {
      var v_Industry_Sector = (rule, value, callback) => {
        if(this.formData.Emp_Status == '1'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Industry_Sector")));
          }
        }
        callback()
      }

      var v_Other_Industry_Sector = (rule, value, callback) => {
        if(this.formData.Emp_Status == '1' && this.formData.Industry_Sector == '16'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Other_Industry_Sector")));
          }else if(value.length >= 30){
            callback(new Error('too long'))
          }
        }
        callback()
      }

      var v_Position = (rule, value, callback) => {
        if(this.formData.Emp_Status == '1'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Position")));
          }
        }
        callback()
      }

      var v_Other_Position = (rule, value, callback) => {
        if(this.formData.Emp_Status == '1' && this.formData.Position == '7'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Other_Position")));
          }else if(value.length >= 30){
            callback(new Error('too long'))
          }
        }
        callback()
      }
      var v_Employer = (rule, value, callback) => {
        if(this.formData.Emp_Status == '1' || (this.formData.Emp_Status == '0' && this.formData.Freelance_OwnACompany == '1')){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Employer")));
          }else if(value.length >= 30){
            callback(new Error('too long'))
          }
        }
        callback()
      }

      var v_Freelance_OwnACompany = (rule, value, callback) => {
        if(this.formData.Emp_Status == '0'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Freelance_OwnACompany")));
          }
        }
        callback()
      }
      var v_Biz_Nature = (rule, value, callback) => {
        if(this.formData.Emp_Status == '0' && (this.formData.Freelance_OwnACompany == '0' || this.formData.Freelance_OwnACompany == '1')){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Biz_Nature")));
          }
        }
        callback()
      }

      var v_Other_Biz_Nature = (rule, value, callback) => {
        if(this.formData.Emp_Status == '0' && this.formData.Biz_Nature == '16'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Other_Biz_Nature")));
          }else if(value.length >= 30){
            callback(new Error('too long'))
          }
        }
        callback()
      }

      var v_Other_Funds_Source = (rule, value, callback) => {
        if(this.formData.Funds_Source == '6'){
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Other_Funds_Source")));
          }else if(value.length >= 30){
            callback(new Error('too long'))
          }
        }
        callback()
      }


      var  v_Afford_To_Lose = (rule, value, callback) => {
        if (!value) return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Afford_To_Lose")));
        this.err_Afford_To_Lose = (value == 'N') ? true:false;
        callback()
      }

      var v_Open_Trading_Account = (rule, value, callback) => {
          if(!value){
            return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Open_Trading_Account")));
          }

        callback()
      }
      var v_Annual_Income_Total = (rule, value, callback) => {
        if(!value){
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Annual_Income_Total")));
        }
        callback()
      }

      var v_Saving_Investments_Money = (rule, value, callback) => {
        if(!value){
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Saving_Investments_Money")));
        }
        callback()
      }

      return {
        obj: {
          a: '0',
          b: '1',
          c: '2',
          d: '3',
          e: '4'
        },
        rules: {
          Emp_Status: [{
            required: true, message:'Above is required'
          }],
          Industry_Sector: [{
            required: true,
            validator: v_Industry_Sector,
            trigger: 'blur'
          }],
          Position: [{
            required: true,
            validator: v_Position,
            trigger: 'blur'
          }],
          Employer: [{
            required: true,
            validator: v_Employer
          }],
          Annual_Income: [{
            required: true, message:'Above is required'
          }],
          Total_Saving_Investments: [{
            required: true, message:'Above is required'
          }],
          Funds_Source: [{
            required: true, message:'Above is required'
          }],
          Intend_Deposit: [{
            required: true, message:'Above is required'
          }],


          Other_Industry_Sector: [{
            required: true,
            validator: v_Other_Industry_Sector,
            trigger: 'blur'
          }],
          Other_Position: [{
            required: true,
            validator: v_Other_Position,
            trigger: 'blur'
          }],
          Biz_Nature: [{
            required: true,
            validator: v_Biz_Nature,
            trigger: 'blur'
          }],
          Other_Biz_Nature: [{
           required: true,
           validator: v_Other_Biz_Nature,
           trigger: 'blur'
          }],
          Other_Funds_Source: [{
            required: true,
            validator: v_Other_Funds_Source,
            trigger: 'blur'
          }],
          Freelance_OwnACompany: [{
            required: true,
            validator: v_Freelance_OwnACompany,
            trigger: 'blur'
          }],

          Afford_To_Lose: [{
            required: true,
            validator: v_Afford_To_Lose,
            trigger: 'change'
          }],
          Open_Trading_Account: [{
            required: true,
            validator: v_Open_Trading_Account,
            trigger: 'blur'
          }],
          Annual_Income_Total: [{
            required: true,
            validator: v_Annual_Income_Total,
            trigger: 'blur'
          }],
          Saving_Investments_Money: [{
            required: true,
            validator: v_Saving_Investments_Money,
            trigger: 'blur',
            max: 20
          }],

        },
        lang:localStorage.getItem('language') === 'en'||false,
        err_Afford_To_Lose:false

      }
    },
    methods: {
      radioChange(val) {
        let arr = ['2', '3', '4']
        if (arr.includes(val)) {
          this.$alert(this.$t('messages.selectEmpStatusTip'), this.$t('ModalMsg.showAlert.title'), {
            confirmButtonText: this.$t('ModalMsg.showAlert.confirmBtnTxt'),
            dangerouslyUseHTMLString: true
          });
        }
      },
      proving(){
        if(isNaN(this.formData.Annual_Income_Total) || this.formData.Annual_Income_Total <= 0){
          this.formData.Annual_Income_Total = '';
        }
      },
      proving2(){
        if(isNaN(this.formData.Saving_Investments_Money) || this.formData.Saving_Investments_Money <= 0){
          this.formData.Saving_Investments_Money = '';
        }
      },
      getPageFormData(cb) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            //更新salesforce步骤
            Util.editSalesforce(this.middle_dataware, 3);
            this.selectTitle();
            return cb(true);
          } else {
            // return cb(true);
            return cb(false);
          }
        });
      },
      selectTitle() {
        let fields = this.$refs['ruleForm'].fields
        if(this.formData.Emp_Status == '1'){
          let arr = ['Freelance_OwnACompany', 'Biz_Nature', 'Other_Biz_Nature']
          if (this.formData.Industry_Sector!=this.getOtherOptVal('Industry_Sector_select')) arr.push('Other_Industry_Sector');
          if (this.formData.Position!=this.getOtherOptVal('FD_Position_select')) arr.push('Other_Position');
          Util.resetField(arr,fields,this.formData)
        } else if(this.formData.Emp_Status == '0'){
          let arr = ['Industry_Sector', 'Other_Industry_Sector', 'Position', 'Other_Position']
          if(this.formData.Freelance_OwnACompany == '0'){
            arr.push(...['Employer'])
          }
          if (this.formData.Biz_Nature!=this.getOtherOptVal('Industry_Sector_select')) arr.push('Other_Biz_Nature');
          Util.resetField(arr,fields,this.formData)
        }else{
          let arr = ['Freelance_OwnACompany', 'Biz_Nature', 'Other_Biz_Nature', 'Employer','Industry_Sector', 'Other_Industry_Sector', 'Position', 'Other_Position', 'Employer'];
          Util.resetField(arr,fields,this.formData)
        }

      },
      getOtherOptVal(otherSelect){
        return Object.keys(this.$t(`financialDetails.${otherSelect}`)).length-1;
      }
    },
      mounted(){
         _g.trackStepPage(3);
         //隐藏 fileds 手动注册
          const add_Fileds = ['Annual_Income_Total','Saving_Investments_Money'];
          let financialDetails = this.$parent.$parent.recodeModel['financialDetails'];
          financialDetails.push(...add_Fileds);
          financialDetails = new Set(financialDetails);
          this.err_Afford_To_Lose = (this.formData.Afford_To_Lose == 'N') ? true:false;

      },
  }
</script>








<style lang="scss">
  .el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
    line-height: normal; 
  }
  .no-left{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .el-form-item__content small {
    // font-family: Roboto;
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    // line-height: normal;
    letter-spacing: 0.3px;
    color: rgba(50, 50, 50, 0.7);
  }
  .personal-detail-3 {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    h4{
      margin-top: 10px !important;
    }
    .form-tip {
      font-size: 11px;
      color: #939597;
      padding: 10px 0;
    }

    .time-icon-color {
      color: #f2672a;
      margin-right: 10px;
    }

    .select-width {
      width: 100%;
    }
    h4{
      font-weight: 400;
      font-size: 15px;
    }
    .el-form-item__label{
      color: black;
    }

    .el-radio__label{
      display: inline-block;
      width: 100%;
      height: auto;
      white-space:normal;
    }
    .radio-list-h5{
      display: flex;
    }
    .radio-h5{
      margin-left: 30px;
    }
    .jz-radio {
      display: flex;
      display: block;
      margin-left: 0;
    }
    @media (max-width: 715px){
      .radio-list-h5{
        display: block;
      }
      .radio-h5{
        margin-left: 0px;
      }
      .jz-radio label{
        display: flex;
        align-items: center;
      }
      .jz-radio span{
        // padding-bottom: 10px;
        display: block;
      }
      .el-form-item--small.el-form-item {
        margin-bottom: 24px;
      }
      .el-form--label-top .el-form-item__label {
        padding: 0 0 16px 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/steps/financialDetails.vue